import { render, staticRenderFns } from "./tradeFlowDetailModal.vue?vue&type=template&id=a89bea08&scoped=true"
import script from "./tradeFlowDetailModal.vue?vue&type=script&lang=js"
export * from "./tradeFlowDetailModal.vue?vue&type=script&lang=js"
import style0 from "./tradeFlowDetailModal.vue?vue&type=style&index=0&id=a89bea08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89bea08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a89bea08')) {
      api.createRecord('a89bea08', component.options)
    } else {
      api.reload('a89bea08', component.options)
    }
    module.hot.accept("./tradeFlowDetailModal.vue?vue&type=template&id=a89bea08&scoped=true", function () {
      api.rerender('a89bea08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/tradeFlowDetailModal.vue"
export default component.exports